import { AnyAction } from 'redux'

import {
  RESET_ERROR,
  SET_ANSWERS,
  SET_ANSWERS_FROM_BACKEND,
  SET_APP_CONFIG,
  SET_DYNAMIC_DISCOUNT,
  SET_ERROR,
  SET_FETCHED_SUBSCRIPTION_TAGS,
  SET_IS_CONTEXT_SHOWN,
  SET_LANGUAGE,
  SET_PAYMENT_CONFIG,
  SET_SCREEN_NAME,
  SET_SUBSCRIPTION_LIST,
  SET_TAX_AMOUNT,
  SET_VARIANT,
  START_FETCHING,
  STOP_FETCHING,
} from 'root-redux/actions/common'

import { IDynamicDiscount, TAnswers } from 'models/common.model'
import { IAppConfig, IPaymentConfig } from 'models/config.model'
import { ISubscription } from 'models/subscriptions.model'
import { IVariant } from 'models/variant.model'

import { ScreenName } from 'services/eventLogger.service'

import { Language, SubscriptionListType } from 'root-constants/common'

const initState: ICommonState = {
  appConfig: null,
  paymentConfig: null,
  actionList: [],
  isFetching: false,
  error: null,
  currentVariant: null,
  subscriptions: [],
  fetchedSubscriptionTags: {},
  answers: null,
  language: Language.EN,
  screenName: ScreenName.ONBOARDING,
  taxAmount: 0,
  isInContextShown: false,
  dynamicDiscount: null,
}

export interface ICommonState {
  appConfig: IAppConfig | null
  paymentConfig: IPaymentConfig | null
  actionList: string[]
  isFetching: boolean
  error: any
  currentVariant: IVariant | null
  subscriptions: ISubscription[]
  fetchedSubscriptionTags: Partial<Record<SubscriptionListType, string>>
  answers: TAnswers | null
  language: Language
  screenName: ScreenName
  taxAmount: number
  isInContextShown: boolean
  dynamicDiscount?: IDynamicDiscount | null
}

export function commonReducer(
  state: ICommonState = initState,
  { type, payload = null }: AnyAction,
): ICommonState {
  switch (type) {
    case START_FETCHING: {
      return {
        ...state,
        isFetching: true,
        actionList: state.actionList.concat(payload),
      }
    }
    case STOP_FETCHING: {
      return {
        ...state,
        isFetching: !!payload.length,
        actionList: payload,
      }
    }
    case SET_ERROR: {
      return {
        ...state,
        error: payload,
      }
    }
    case RESET_ERROR: {
      return {
        ...state,
        error: null,
      }
    }
    case SET_VARIANT: {
      return {
        ...state,
        currentVariant: payload,
      }
    }
    case SET_SUBSCRIPTION_LIST: {
      return {
        ...state,
        subscriptions: payload,
      }
    }
    case SET_FETCHED_SUBSCRIPTION_TAGS: {
      return {
        ...state,
        fetchedSubscriptionTags: {
          ...state.fetchedSubscriptionTags,
          [payload.subscriptionType]: payload.tags,
        },
      }
    }
    case SET_APP_CONFIG: {
      return {
        ...state,
        appConfig: payload,
      }
    }
    case SET_PAYMENT_CONFIG: {
      return {
        ...state,
        paymentConfig: payload,
      }
    }
    case SET_ANSWERS: {
      return {
        ...state,
        answers: { ...state.answers, ...payload },
      }
    }
    case SET_ANSWERS_FROM_BACKEND: {
      return {
        ...state,
        answers: payload,
      }
    }
    case SET_LANGUAGE: {
      return {
        ...state,
        language: payload,
      }
    }
    case SET_SCREEN_NAME: {
      return {
        ...state,
        screenName: payload,
      }
    }
    case SET_TAX_AMOUNT: {
      return {
        ...state,
        taxAmount: payload,
      }
    }
    case SET_IS_CONTEXT_SHOWN: {
      return {
        ...state,
        isInContextShown: payload,
      }
    }
    case SET_DYNAMIC_DISCOUNT: {
      return {
        ...state,
        dynamicDiscount: payload,
      }
    }
    default:
      return state
  }
}
